import { success, failure, request } from 'app/actions';
import * as actions from './simulatedQuestionsActions';
import * as helpers from './simulatedQuestionsHelper';

const initialState = {
  evaluation: null,
  questionsData: {
    questions: [],
  },
  contract: {},
  currentQuestion: undefined,
  error: {},
  completed: false,
  forbidden: undefined,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case request(actions.APPROVE_QUESTION):
      return {
        ...state,
        error: { ...state.error, approveQuestion: initialState.error.approveQuestion },
      };
    case request(actions.REPROVE_QUESTION):
      return {
        ...state,
        error: { ...state.error, reproveQuestion: initialState.error.reproveQuestion },
      };
    case failure(actions.APPROVE_QUESTION):
      return { ...state, error: { ...state.error, approveQuestion: action.payload.error } };
    case failure(actions.REPROVE_QUESTION):
      return { ...state, error: { ...state.error, reproveQuestion: action.payload.error } };
    case request(actions.APPROVE_EVALUATION):
      return { ...state, error: { ...state.error, approve: initialState.error.approve } };
    case failure(actions.APPROVE_EVALUATION):
      return { ...state, error: { ...state.error, approve: action.payload.error } };
    case request(actions.GET_EVALUATION):
      return {
        ...state,
        evaluation: initialState.evaluation,
        completed: initialState.completed,
        forbidden: initialState.forbidden,
        contract: initialState.contract,
      };
    case success(actions.GET_EVALUATION):
      return {
        ...state,
        evaluation: helpers.getEvaluation(action.payload.content),
        completed: action.payload.content.evaluation.dates.some(
          (d) => d.component === 'questions' && d.complete,
        ),
        contract: action.payload.content.contract,
        forbidden: false,
      };
    case failure(actions.GET_EVALUATION):
      return {
        ...state,
        forbidden: true,
      };
    case request(actions.GET_QUESTION):
      return { ...state, currentQuestion: initialState.currentQuestion };
    case success(actions.GET_QUESTION):
      return { ...state, currentQuestion: action.payload.content.currentQuestion };
    case request(actions.GET_QUESTIONS):
      return {
        ...state,
        questionsData: initialState.questionsData,
        currentQuestion: initialState.currentQuestion,
      };
    case success(actions.GET_QUESTIONS):
      return {
        ...state,
        questionsData: helpers.getQuestionsData(action.payload.content),
        currentQuestion: action.payload.content.currentQuestion,
      };
    default:
      return state;
  }
};

export default reducer;
